import { render, staticRenderFns } from "./ProjectTestModelPhaseChangedWarningModal.vue?vue&type=template&id=1e20d126"
import script from "./ProjectTestModelPhaseChangedWarningModal.vue?vue&type=script&lang=js"
export * from "./ProjectTestModelPhaseChangedWarningModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports